import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { TimeSlot } from '@checkout-v2/const';
import { ItemWrapperComponent } from '../item-wrapper';
import { AnotherDateItemComponent } from './another-date-item';
import { TimeSlotDateItemComponent } from './time-slot-date-item';

@Component({
  selector: 'sd-time-slot-dates',
  imports: [TimeSlotDateItemComponent, AnotherDateItemComponent, ItemWrapperComponent, DatePipe],
  templateUrl: './time-slot-dates.component.html',
  styleUrl: './time-slot-dates.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSlotDatesComponent {
  readonly timeSlots = input.required<TimeSlot[]>();
  readonly selectedTimeSlot = input.required<TimeSlot | undefined>();
  readonly selectedDate = model<string>();
  readonly selectedAnotherDate = model<string | undefined>();

  onSelectAnotherDate(date: string): void {
    const hasTimeSlotWithDate = this.timeSlots().some((slot) => slot.date === date);

    if (!hasTimeSlotWithDate) {
      this.selectedAnotherDate.set(date);
    }

    this.selectedDate.set(date);
  }

  onSelectDate(date: string): void {
    this.selectedDate.set(date);
  }
}
